import { createFileRoute, notFound, useNavigate } from '@tanstack/react-router';
import { Button } from 'primereact/button';
import { Breadcrumb } from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';
import { HeaderContainer } from '~/components/ui/layout/page/HeaderContainer';
import { NotFoundPage } from '~/components/ui/common/NotFoundPage';
import { PortfoliosTable } from '~/components/ui/tables/ag/portfolios/portfoliosTable';
import {
  endpointPortfolioCompanyGET,
  PortfolioCompanyResponse,
} from '~/api/def/endpoints/portfolioCompanyEndpoint';
import { useQuery } from '@tanstack/react-query';
import { canAccess } from '~/utils/rbac';
import { useRequireFeatureFlag } from '~/hooks/useRequireFeatureFlag';
import { FEATURE_FLAGS } from '~/config/orgConfigConstants';

const PortfoliosRoute = () => {
  const { allowed } = useRequireFeatureFlag(FEATURE_FLAGS.PORTFOLIO_MANAGEMENT);
  if (!allowed)
    return (
      <NotFoundPage message="Page not found. You don't have access to this section." />
    );
  return <DocumentsComponent />;
};

export const Route = createFileRoute('/_authLayout/portfolios')({
  beforeLoad: async () => {
    if (!canAccess('portfolio')) {
      throw notFound();
    }
  },
  component: PortfoliosRoute,
});

function DocumentsComponent() {
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['portfolioCompanyGET'],
    queryFn: () => endpointPortfolioCompanyGET(),
  });

  const rowData = data as PortfolioCompanyResponse[] | undefined;

  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
      }}
    >
      <div className="h-4rem">
        <HeaderContainer>
          <Breadcrumb
            items={[
              { name: 'Funds', url: '/fund/overview' },
              { name: 'Portfolios' },
            ]}
          />
        </HeaderContainer>
      </div>

      <div
        className="p-4"
        style={{
          height: 'calc(100% - 4rem)',
        }}
      >
        <div className="flex justify-between h-3rem">
          <Button
            onClick={() => navigate({ to: '/portfolio/create' })}
            className="mb-3"
          >
            Create Company
          </Button>
        </div>
        <div
          style={{
            height: 'calc(100% - 3rem)',
          }}
        >
          <PortfoliosTable rowData={rowData || []} loading={isLoading} />
        </div>
      </div>
    </div>
  );
}
